import { connectStats } from 'react-instantsearch/connectors';
import React from 'react';
import ExhibitorTotal from './ExhibitorTotal';

export default connectStats(({ nbHits, defaultTitle, tags }) => <ExhibitorTotal total={nbHits} defaultTitle={defaultTitle} tags={tags} />);
